import React, { useEffect, useState } from "react";
import altare from "../assets/Group.png";
import failImage from "../assets/illustration_device-error_270.png";
import en from "../assets/lang/en.json";

const Error = () => {
  const [data, setData] = useState({});
  useEffect(() => {
    setData(en);
  }, []);
  return (
    <div className="container">
        <div className="container-success">
            <div className="container-logo">
                <div className="logo" style={{ height: '200px' }}>
                    <img src={failImage} alt="ping" style={{ width: "140px", height: '140px', borderRadius: '10px' }}></img>
                </div>
                <div className="success-text">{data.restrict}</div>
                <div className="redirect-text" style={{width:"57%"}}>{data.restrictText}</div>
            </div>
            <div className="footer-text">Powered by
                <img src={altare} alt="powered-logo" style={{ width: "50px", height: '20px' }} />
            </div>
        </div>
    </div>
    // <div className="container">
    //   <div className="inner-container">
    //     <div>
    //       <div className="image-loader">
    //         <img
    //           src={loader_gif}
    //           alt="Gif"
    //           style={{
    //             width: "48px",
    //             height: "48px",
    //             borderRadius: "10px",
    //           }}
    //         ></img>
    //       </div>
    //       <div className="inner-text">
    //        { `You'll be redirected to tpp. Don't close this window as we take you back.`}
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default Error;
